import { useGetExercisePresetsDetail } from '#api/exercise-presets';
import { useExercisePresetRecoil } from '#states/exercisePresetsState';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useEffect } from 'react';
import BottomSheet from 'src/components/shared/BottomSheet';
import { Input } from 'src/components/shared/Input/Input';
import { ExerciseList } from 'src/components/shared/exercise/exercise-list';
import { Required } from 'src/shared/components/client-registration/styles';
import { SubmitButton } from './SubmitButton';

interface AddPresetsBottomSheetProps {
  openBottomSheet: boolean;
  setOpenBottomSheet: (value: boolean) => void;
  id?: string;
}

/**
 * @param id - 프리셋 아이디  (프리셋 수정 시 필요)
 */
export const ChangePresetsBottomSheet = ({
  openBottomSheet,
  setOpenBottomSheet,
  id
}: AddPresetsBottomSheetProps) => {
  // 사용자가 입력한 프리셋 정보
  const { exercisePresets, setExercisePresets } = useExercisePresetRecoil();

  // 프리셋 제목 변경
  const onChangePresetTitle = (title: string) => {
    setExercisePresets(prev => ({ ...prev, name: title }));
  };

  useEffect(() => {
    if (exercisePresets.exercisePresetWorkout.length === 0) {
      setExercisePresets({
        name: '',
        exercisePresetWorkout: [
          {
            exerciseTypeId: '',
            sets: [
              {
                weight: 0,
                reps: 0,
                time: 0,
                setType: 'REPWEIGHT',
                round: 0
              }
            ]
          }
        ]
      });
    }
  }, [exercisePresets]);

  // 프리셋 수정시 필요한 상세 조회
  const { data } = useGetExercisePresetsDetail(id);

  useEffect(() => {
    if (data) {
      setExercisePresets(data);
    }
  }, [data]);

  // bottom sheet 닫기
  const onClose = () => {
    setOpenBottomSheet(false);
  };

  return (
    <BottomSheet
      isOpen={openBottomSheet}
      handleClose={onClose}
      showHeader={false}
      closableBackground
      fullHeight
      bodyStyle={{ padding: '0px' }}
    >
      <PrevHeaderBarWithTitleTemplate
        title={id ? '프리셋 수정' : '프리셋 추가'}
        hasXButton
        onXButtonClick={() => {
          setOpenBottomSheet(false);
          setExercisePresets({
            name: '',
            exercisePresetWorkout: [
              {
                exerciseTypeId: '',
                sets: [
                  {
                    weight: 0,
                    reps: 0,
                    time: 0,
                    setType: 'REPWEIGHT',
                    round: 0
                  }
                ]
              }
            ]
          });
        }}
        rightContents={<SubmitButton id={id} onClose={onClose} />}
        defaultBackground
      >
        <div className="p-20">
          <div className="flex flex-col gap-12">
            <div className="flex gap-4 items-center">
              <div>프리셋 제목</div>
              <Required>*</Required>
            </div>

            <Input
              value={exercisePresets.name}
              onChange={e => {
                onChangePresetTitle(e.target.value);
              }}
              placeholder="프리셋 이름을 적어주세요"
              onReset={() => onChangePresetTitle('')}
            />
          </div>
          <ExerciseList exerciseList={exercisePresets.exercisePresetWorkout} />
        </div>
      </PrevHeaderBarWithTitleTemplate>
    </BottomSheet>
  );
};
